<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div class="p-fluid">
  <app-warehousing-page-header activeSection="destruction" title="Destruction"
    subtitle="Create draft stock write-offs, then confirm them to reduce on-hand quantity and post a destruction ledger movement.">
    <div actions class="flex gap-2">
      @if (canCreate()) {
        <p-button label="Create Destruction" icon="pi pi-plus" severity="danger" routerLink="/warehousing/destruction/add"></p-button>
      }
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadDestructions()"></p-button>
    </div>
  </app-warehousing-page-header>

  <app-warehousing-search-panel title="Search Destruction" [resultCount]="destructions.length" [totalCount]="destructions.length" (search)="applySearch()" (clear)="clearSearch()">
    <div [formGroup]="searchForm" class="formgrid grid">
      <div class="field col-12 md:col-6">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel><input id="destructionKeyword" pInputText formControlName="keyword"><label for="destructionKeyword">Keyword</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-cog"></i></p-inputGroupAddon><p-iftaLabel><p-select id="destructionSource" [options]="destructionSources" optionLabel="label" optionValue="value" formControlName="sourceType" [showClear]="true" styleClass="w-full"></p-select><label for="destructionSource">Source</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon><p-iftaLabel><p-select id="destructionStatus" [options]="destructionStatusOptions" optionLabel="label" optionValue="value" formControlName="status" [showClear]="true" styleClass="w-full"></p-select><label for="destructionStatus">Status</label></p-iftaLabel></p-inputGroup>
      </div>
    </div>
  </app-warehousing-search-panel>

  <section class="warehousing-table-card">
    <div class="warehousing-table-header">
      <div>
        <h2>Destruction Register</h2>
        <p>Track draft, confirmed, and cancelled destruction write-offs.</p>
      </div>
      <span class="warehousing-result-chip">{{ destructions.length }} records</span>
    </div>

    <p-table [value]="destructions" [paginator]="true" [rows]="12" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[12, 25, 50]" [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template pTemplate="header"><tr><th>Destruction</th><th>Source / Supplier</th><th>Reason</th><th>Qty / Status</th><th>Audit</th><th class="text-center">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <div class="stack-cell">
              <span class="warehousing-code-pill">{{ row.destructionNumber || ('Draft #' + row.id) }}</span>
              <span class="cell-title">{{ itemName(row.itemId) }}</span>
              <span class="cell-meta"><i class="pi pi-box"></i> Stock Unit {{ row.stockUnitId }}</span>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <span class="cell-title">{{ row.sourceType }}</span>
              <span class="cell-meta"><i class="pi pi-building"></i> {{ supplierName(row) }}</span>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <span class="cell-title">{{ row.reason || '-' }}</span>
              <span class="cell-meta"><i class="pi pi-calendar"></i> {{ row.requestedDate || '-' }}</span>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag>
              <div class="cell-meta vertical">
                <div class="quality-pill">Qty {{ (row.quantityDestroyed || 0) | number:'1.0-2' }}</div>
                <span>Est. {{ (row.estimatedCost || 0) | number:'1.2-2' }}</span>
              </div>
            </div>
          </td>
          <td><app-audit-directory-cell [stamp]="row"></app-audit-directory-cell></td>
          <td class="text-center"><div class="warehousing-row-actions"><p-button icon="pi pi-eye" [text]="true" [routerLink]="['/warehousing/destruction/view', row.id]"></p-button></div></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="6"><div class="warehousing-empty-state"><i class="pi pi-search"></i><strong>No destruction records found</strong><span>No matching destruction records.</span></div></td></tr></ng-template>
    </p-table>
  </section>
</div>
